export const BRANDS_API_PATHS = {
  brands: "/brands",
  topDeals: "/brands/top-deals",
  brandProducts: (brandSlug: string, page: number, limit: number) => {
    const offset = Math.max(0, (page - 1) * limit);
    return `/brands/${encodeURIComponent(brandSlug)}/products?limit=${limit}&offset=${offset}`;
  },
} as const
